module.exports = __webpack_public_path__ + "static/Alicia_new-9dc029fa4de25a46bc384dc04dba5e79.svg";